import { createServiceLayerAuthClient } from "@appic/service-layer";

/**
 * Auth client configuration.
 * 
 * CRITICAL: VITE_SITE_ORIGIN must be set to the public origin of the SPA
 * (e.g., "https://portal.clanda.de" or "https://scout.clanda.de").
 * 
 * If VITE_SITE_ORIGIN is not set, the package will fall back to window.location.origin,
 * which may be incorrect if the app is accessed via a different domain.
 */
export const authClient = createServiceLayerAuthClient({
  siteOrigin: import.meta.env.VITE_SITE_ORIGIN,
  serviceLayerBaseUrl: import.meta.env.VITE_SERVICE_LAYER_BASE_URL || "/service",
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || ''
});

